import mondaySdk from "monday-sdk-js";
import { CheckoutSource, CheckoutSources } from "./checkout";
import { useState, useCallback } from "react";
import { isCIM } from "utils/url-utils";

const monday = mondaySdk();

type CheckoutFlowState = CheckoutSource | null;
type SetCheckoutFlowState = (source: CheckoutSource | null) => void;

const CHECKOUT_SOURCES_TO_UNLOCK_FEATURES_MAP: Record<CheckoutSources, string> = {
  templates: "workcanvas_premium_templates",
  "video-call": "workcanvas_video_calls",
  "org-chart-nodes": "workcanvas_orgchart_nodes",
  "org-chart-fields": "workcanvas_orgchart_fields",
  "monday-integration": "workcanvas_integrations_limit",
  "monday-integration-limit": "workcanvas_integrations_limit",
  general: "workcanvas_canvas_limit",
  "elements-limit": "workcanvas_elements_limit",
  "public-boards": "workcanvas_canvas_limit",
  "create-template": "workcanvas_custom_templates",
  "premium-shapes": "workcanvas_shape_libraries",
  gantt: "workcanvas_ganttchart",
  "cim-max-boards-reached": "workcanvas_canvas_limit",
};
function useCheckoutFlow(): [CheckoutFlowState, SetCheckoutFlowState] {
  const [internalShowUpgradeModal, setInternalShowUpgradeModal] = useState<CheckoutFlowState>(null);

  const setShowUpgradeModal = useCallback((source: CheckoutFlowState) => {
    if (isCIM()) {
      monday.execute("openFeatureLockModal", {
        unlockFeature: CHECKOUT_SOURCES_TO_UNLOCK_FEATURES_MAP[source?.name ?? "general"],
        unlockFeatureConfig: null,
        unlockFeatureSettings: {},
      });
    } else {
      setInternalShowUpgradeModal(source);
    }
  }, []);

  return [internalShowUpgradeModal, setShowUpgradeModal];
}

export default useCheckoutFlow;
